/* Cart Drawer (Grizzled Geek Games)
   - Opens on add-to-cart, loads /cart.js, updates via /cart/change.js
   - Qty +/- and remove
   - Saves note via /cart/update.js (debounced)
   - Discount "Apply" redirects to /discount/CODE?redirect=/cart (to keep code)
*/

(function(){
  var drawer = document.getElementById('ggg-cart-drawer');
  if (!drawer) return;

  var panel = drawer.querySelector('[data-drawer-panel]');
  var overlayBtns = drawer.querySelectorAll('[data-cart-close]');
  var itemsWrap = drawer.querySelector('[data-cart-items]');
  var emptyWrap = drawer.querySelector('[data-cart-empty]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var noteWrap = drawer.querySelector('[data-cart-note-wrap]');
  var noteInput = drawer.querySelector('[data-cart-note]');
  var discountWrap = drawer.querySelector('[data-cart-discount-wrap]');
  var discountInput = drawer.querySelector('[data-cart-discount-input]');
  var discountBtn = drawer.querySelector('[data-apply-discount]');
  var itemTemplate = document.getElementById('ggg-cart-item-template');
  var moneyFormat = drawer.getAttribute('data-money-format');
  var busy = false;

  function fmtMoney(cents){
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch(e){}
    var n = (parseInt(cents, 10) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function openDrawer(){
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(function(){ panel && panel.focus(); }, 10);
    document.documentElement.classList.add('ggg-cart-open');
  }

  function closeDrawer(){
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ggg-cart-open');
  }

  overlayBtns.forEach(function(btn){ btn.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeDrawer();
  });

  function setBusy(b){ busy = !!b; drawer.toggleAttribute('data-busy', busy); }

  function renderCart(cart){
    // Toggle empty vs items
    var isEmpty = !cart.items || cart.items.length === 0;
    itemsWrap.innerHTML = '';
    emptyWrap.hidden = !isEmpty;
    if (noteWrap) noteWrap.hidden = isEmpty;
    if (discountWrap) discountWrap.hidden = isEmpty;

    subtotalEl.textContent = fmtMoney(cart.items_subtotal_price);

    if (noteInput) noteInput.value = cart.note || '';

    if (isEmpty) return;

    cart.items.forEach(function(it, idx){
      var tpl = itemTemplate.content.cloneNode(true);
      var root = tpl.querySelector('[data-line]');
      var hrefEls = tpl.querySelectorAll('[data-href]');
      var titleEl = tpl.querySelector('[data-title]');
      var imageEl = tpl.querySelector('[data-image]');
      var variantEl = tpl.querySelector('[data-variant]');
      var propsEl = tpl.querySelector('[data-properties]');
      var qtyInput = tpl.querySelector('[data-qty-input]');
      var minusBtn = tpl.querySelector('[data-qty-decrease]');
      var plusBtn  = tpl.querySelector('[data-qty-increase]');
      var removeBtn= tpl.querySelector('[data-remove]');
      var linePrice= tpl.querySelector('[data-line-price]');
      var compareEl= tpl.querySelector('[data-compare-at]');

      var line = idx + 1;
      root.setAttribute('data-line', String(line));

      // Links
      hrefEls.forEach(function(a){ a.href = it.url; });
      titleEl.textContent = it.product_title || it.title || 'Item';
      titleEl.href = it.url;

      // Image
      if (imageEl && it.image) {
        var src = it.image;
        if (src.indexOf('?') === -1) src += '?width=360';
        imageEl.src = src;
        imageEl.alt = it.product_title || '';
      }

      // Variant
      var variantTxt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      variantEl.textContent = variantTxt;

      // Properties
      if (it.properties) {
        var props = [];
        for (var k in it.properties){
          if (!it.properties.hasOwnProperty(k)) continue;
          var v = it.properties[k];
          if (v == null || v === '') continue;
          props.push(k + ': ' + v);
        }
        propsEl.innerHTML = props.map(function(p){ return '<div>'+escapeHtml(p)+'</div>'; }).join('');
      }

      // Quantity
      qtyInput.value = it.quantity;
      minusBtn.addEventListener('click', function(){ changeQty(line, Math.max(0, parseInt(qtyInput.value||0,10)-1)); });
      plusBtn.addEventListener('click', function(){ changeQty(line, (parseInt(qtyInput.value||0,10)+1)); });
      qtyInput.addEventListener('change', function(){
        var q = parseInt(qtyInput.value||0,10);
        if (isNaN(q) || q < 0) q = 0;
        changeQty(line, q);
      });

      // Remove
      removeBtn.addEventListener('click', function(){ changeQty(line, 0); });

      // Prices
      linePrice.textContent = fmtMoney(it.line_price);
      if (it.original_line_price && it.original_line_price > it.line_price) {
        compareEl.textContent = fmtMoney(it.original_line_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }

      itemsWrap.appendChild(tpl);
    });
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g,function(m){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]);
    });
  }

  function fetchCart(){
    return fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); return cart; })
      .catch(function(){});
  }

  function changeQty(line, quantity){
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r){ return r.json(); })
    .then(function(){ return fetchCart(); })
    .finally(function(){ setBusy(false); });
  }

  // Save note (debounced)
  var noteTimer = 0;
  if (noteInput){
    noteInput.addEventListener('input', function(){
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function(){
        fetch('/cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body: JSON.stringify({ note: noteInput.value || '' })
        }).catch(function(){});
      }, 400);
    });
  }

  // Apply discount (redirect to keep code applied)
  if (discountBtn && discountInput){
    discountBtn.addEventListener('click', function(){
      var code = (discountInput.value || '').trim();
      if (!code) return;
      var redirect = encodeURIComponent('/cart');
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + redirect;
    });
  }

  // Intercept add-to-cart submissions to open drawer
  function hookAddToCart(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.action || form.getAttribute('data-no-ajax')) return;
      if (form.action.indexOf('/cart/add') === -1) return;

      e.preventDefault();
      var data = new FormData(form);
      setBusy(true);
      fetch('/cart/add.js', {
        method:'POST',
        body:data,
        credentials:'same-origin',
        headers:{'Accept':'application/json'}
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        return fetchCart();
      })
      .then(function(){
        openDrawer();
      })
      .catch(function(){ /* fallback: just open & reload cart */ openDrawer(); })
      .finally(function(){ setBusy(false); });
    }, true);

    // Also catch common ATC buttons that call fetch under the hood:
    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t) return;
      // If theme already added to cart and auto-open is true, we still ensure refresh when custom event fires
    });

    // If theme dispatches a custom event after add, listen for it
    document.addEventListener('product:added', function(){
      fetchCart().then(openDrawer);
    });
  }

  // Initialize
  fetchCart();
  hookAddToCart();

})();
